import { InteractiveElementsList } from "@pjs/core-ui";

export const focusFirstInteractiveOrFallback = (contentElement: HTMLElement | null, fallback: () => void | null, exclusions?: Array<HTMLElement>): void => {
    if (contentElement === null) {
        fallback();
        return;
    }

    let elementToFocus: HTMLElement | null = null;

    const interactiveElementsList = new InteractiveElementsList(contentElement);

    for (const element of interactiveElementsList) {
        if (exclusions === undefined) {
            elementToFocus = element;
            break;
        }

        if (!exclusions.includes(element)) {
            elementToFocus = element;
            break;
        }
    }

    if (elementToFocus === null) {
        fallback();
    } else {
        elementToFocus.focus();
    }
};
